import { Tooltip } from 'antd'
import { ReactElement, useEffect, useRef, useState } from 'react'
import { Button } from '../../atoms'

import styles from './_.module.css'

type Props = {
  className?: string
  children?: ReactElement | string
  // max lines of text to be shown
  maxLines?: number
  // add read more button to show the full text on click
  readMore?: boolean
  showTooltip?: boolean
}
export const Text = ({
  className = '',
  children,
  maxLines = 1,
  readMore = false,
  showTooltip
}: Props): ReactElement => {
  const [isExpanded, setExpanded] = useState(false)
  const textField = useRef<HTMLElement>(null)

  const isTextClamped = (element: HTMLElement | null) => {
    if (element) return element.scrollHeight > element.clientHeight
    return false
  }

  useEffect(() => {
    const element = textField.current

    // check if the text is clamped
    setExpanded(isTextClamped(element))

    //   add line clamp style to the element
    element?.setAttribute('style', `-webkit-line-clamp: ${maxLines}`)
  }, [textField, maxLines])

  useEffect(() => {
    const element = textField.current

    //   add line clamp style to the element
    if (isExpanded) {
      element?.setAttribute('style', `-webkit-line-clamp: unset`)
    } else {
      element?.setAttribute('style', `-webkit-line-clamp: ${maxLines}`)
    }
  }, [isExpanded])

  return (
    <span className={className}>
      {showTooltip ? (
        <Tooltip
          title={children}
          placement="bottomLeft"
          getPopupContainer={(trigger): HTMLElement => trigger}
        >
          <span className={styles.text} ref={textField}>
            {children}
          </span>
        </Tooltip>
      ) : (
        <span className={styles.text} ref={textField}>
          {children}
        </span>
      )}
      {readMore && !isExpanded && (
        <Button type="link" onClick={() => setExpanded(true)} size="small">
          Read More
        </Button>
      )}
      {readMore && isExpanded && (
        <Button type="link" onClick={() => setExpanded(false)} size="small">
          Hide
        </Button>
      )}
    </span>
  )
}
